const queries = {
  dashboardStatus: () => ['dashboard/status'],
}

export default queries
